import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
var font = variables.font,
  input = variables.input;
var colors = tokens.colors;
export var container = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var label = /*#__PURE__*/css("display:inline-block;font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";line-height:", font.baseLineHeight, ";font-weight:", font.headingFontWeight, ";color:", colors.neutral.surface.base, ";margin-bottom:15px;");
export var selectContainer = {
  name: "1o1u8nf",
  styles: "display:inline-block;vertical-align:middle;width:122px;"
};
export var select = () => /*#__PURE__*/css("> div > button{font-family:", font.bodyFontFamily, ";color:", colors.neutral.surface.base, ";font-size:", font.smallFontSize, ";padding:", input.vPadding, " ", input.hPadding, ";border:1px solid ", colors.neutral.trim.default, ";box-shadow:unset;:focus{border:1px solid ", colors.neutral.subdued.pressed, ";box-shadow:0 0 0 1px ", colors.neutral.subdued.pressed, ";}}> div::after{top:calc(10px + ", input.vPadding, ");right:", input.hPadding, ";}> div:nth-of-type(2){border:1px solid ", colors.neutral.subdued.pressed, ";box-shadow:0 0 0 1px ", colors.neutral.subdued.pressed, ";border-top:unset;> div:first-of-type{div{font-family:", font.bodyFontFamily, ";color:", colors.neutral.surface.base, ";font-size:", font.smallFontSize, ";padding:", input.vPadding, " ", input.hPadding, ";}}}");
export var applyButton = {
  name: "35wqrn",
  styles: "margin-top:15px;text-align:right;"
};
export var clear = /*#__PURE__*/css("float:right;padding:0;min-height:auto;font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";color:", colors.neutral.base.default, ";");
export var selectSeparator = {
  name: "1aoqav5",
  styles: "padding:0 15px;"
};
export var wrapper = {
  name: "epvm6",
  styles: "white-space:nowrap;"
};